import React, { useEffect, useState } from 'react'
import { TextField, RenderCurrencyFormatTextField, Button } from '@components/atoms'
import {
	Modal,
	FormControlLabel,
	Switch,
	Box,
	Typography,
	IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { ProductType, ProductUpdateType } from '@schemas'

interface ProductModificationModalProps {
	open: boolean
	onClose: () => void
	onSubmit: (product: ProductUpdateType) => void
	initialValues: ProductType
}

export const ProductModificationModal: React.FC<ProductModificationModalProps> = ({
	open,
	onClose,
	onSubmit,
	initialValues,
}) => {
	const [name, setName] = useState('')
	const [code, setCode] = useState('')
	const [usd, setUsd] = useState('')
	const [index, setIndex] = useState('')
	const [useYn, setUseYn] = useState(true)

	useEffect(() => {
		if (initialValues) {
			setName(initialValues.name)
			setCode(initialValues.code)
			setUsd(initialValues.usd.toString())
			setIndex(initialValues.index.toString())
			setUseYn(initialValues.useYn === 1)
		}
	}, [initialValues])

	const handleModify = () => {
		if (name && usd && index && initialValues.id !== '') {
			onSubmit({
				id: initialValues?.id || '',
				code,
				name,
				usd: Number(usd),
				krw: initialValues.krw,
				discountUsd: initialValues.discountUsd,
				discountKrw: initialValues.discountKrw,
				quantity: initialValues.quantity,
				index: Number(index),
				useYn: useYn ? 1 : 0,
				alwaysAvailableYn: initialValues.alwaysAvailableYn,
				soldoutYn: initialValues.soldoutYn,
			})
			onClose()
		}
	}

	return (
		<Modal open={open} onClose={onClose}>
			<Box component="div" sx={styles.modalContent}>
				<IconButton onClick={onClose} sx={styles.closeButton} aria-label="close">
					<CloseIcon />
				</IconButton>
				<Typography variant="h5" component="h2" sx={styles.title}>
					제품 수정
				</Typography>
				<TextField
					label="제품명"
					value={name}
					onChange={e => setName(e.target.value)}
					fullWidth
					margin="normal"
				/>
				<TextField
					label="제품코드"
					value={code}
					onChange={e => setCode(e.target.value)}
					fullWidth
					margin="normal"
				/>
				<TextField
					label="가격 (USD)"
					value={usd}
					onChange={e => setUsd(e.target.value)}
					fullWidth
					margin="normal"
					InputProps={{
						inputComponent: RenderCurrencyFormatTextField,
					}}
				/>
				<TextField
					label="인덱스"
					value={index}
					onChange={e => setIndex(e.target.value)}
					fullWidth
					margin="normal"
				/>
				<FormControlLabel
					control={
						<Switch
							checked={useYn}
							onChange={e => setUseYn(e.target.checked)}
							color="primary"
						/>
					}
					label="사용 여부"
					sx={styles.switch}
				/>
				<Button onClick={handleModify} variant="contained" color="primary" fullWidth>
					수정하기
				</Button>
			</Box>
		</Modal>
	)
}

const styles = {
	modalContent: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '400px',
		backgroundColor: 'white',
		boxShadow:
			'0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
		padding: '32px',
		borderRadius: '8px',
		textAlign: 'center',
	},
	closeButton: {
		position: 'absolute',
		right: '8px',
		top: '8px',
	},
	title: {
		marginBottom: '16px',
	},
	switch: {
		marginTop: '16px',
		marginBottom: '24px',
	},
}
